<template>

    <div class="form-group">
        <label :for="inputId">{{ inputLabel }}*<span v-if="subLabel" :class="{ 'has-date' : hasDate, 'has-no-date' : ! hasDate }" v-html="subLabel"></span></label>
        <textarea class="form-control" :value="value" :id="inputId" rows="5" :placeholder="inputPlaceholder" @input="$emit('input', $event.target.value)"></textarea>
    </div>

</template>

<script>

export default {

    props: {

        value: {
            type: String,
            required: true
        },

        inputLabel: {
            type: String,
            required: true
        },

        subLabel: {
            type: String,
            required: false
        },

        inputPlaceholder: {
            type: String,
            required: false,
            default : ''
        },

        inputId: {
            type: String,
            required: true
        },

        hasDate: {
            type: Boolean,
            default : false
        },
    }
}

</script>